import {
  type AppliedAttributeFilter,
  type GetSearchResultsPageByUrlQuery,
} from '@/generated/graphql-types'
import { type SearchActionsResult } from '@/hooks/srp/useSearchActions'
import { trackEvent } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'
import { sendToLogger } from '@/utils/sendToLogger'

import { updateAttributeFilterGroup } from './updateAttributeFilterGroup'
import { updateMultiselectFilter } from './updateMultiselectFilter'

export const selectAttributeValue = async ({
  appliedFilters,
  data,
  isSingleSelect,
  name,
  newValue,
  refetchResults,
  selectedValues,
}: {
  appliedFilters: AppliedAttributeFilter[]
  data?: GetSearchResultsPageByUrlQuery['searchResultsPageByUrl']
  isSingleSelect?: boolean
  name: string
  newValue: string
  refetchResults: SearchActionsResult['refetchResults']
  selectedValues: string[]
}) => {
  /**  It is formatting values twice - Figure out a way to simplify this */
  const updatedValues = updateMultiselectFilter({ isSingleSelect, newValue, selectedValues })
  const updatedAttributeFilters = updateAttributeFilterGroup({
    canonicalName: name,
    currentAttributes: appliedFilters,
    newAttributeValues: updatedValues,
  })

  trackEvent({
    action: GA_EVENT.FilterSelectAttributeAttempt,
    label: `${name}=[${updatedValues.join(', ')}]`,
  })

  if (!data) {
    trackEvent({ action: GA_EVENT.FilterSelectFail })
    sendToLogger('"SelectAttributeValue" called with no data', {
      tags: {
        component: 'SRP Filters',
        fn: 'selectAttributeValue',
        name,
        newValue: JSON.stringify(newValue),
      },
    })
    return
  }

  await refetchResults(data, { newAttributeFilters: updatedAttributeFilters })
}
